<div class="profile-container">
  <div class="">
      <div class="profile-content">
        <!-- <button class="add-Sub-Ticket" data-toggle="modal" data-target="#exampleModal">Add Sub-Ticket Type</button>

          <div class="personal-details">
              <h4 class="personal-details-title">Sub-Ticket Type</h4>
              <table class="table table-striped" >
                  <thead>
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">Ticket-sub Type</th>
                      <th scope="col">Remarks</th>
                      <th scope="col">Version</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let x of sub_ticket;let i = index">
                      <th scope="col">{{i+1}}</th>
                      <th scope="col">{{x.name}}</th>
                      <th scope="col">{{x.remarks}}</th>
                      <th scope="col">{{x.version }}</th>
                  
                    </tr>
                       
                  </tbody>
              </table>
          </div> -->

          <div class="personal-details">

            <div class="header-block">
                <div class="header-title">
                    <p>Sub Ticket Type</p>
                </div>
                <div class="add-block">
                  <div class="search">
                    <form autocomplete="off" >
                          <!-- <i class="bi bi-x-lg"></i> -->
                          <input type="text" [ngModelOptions]="{standalone: true}" placeholder="search product" [(ngModel)]="searchKey">
                    </form>
                    <i class="bi bi-x-lg" (click)="refreshSearch()" *ngIf="searchKey != ''"></i>

                    <i class="bi bi-search" (click)="getTicketSubTypeByWildSearch(0,10)"></i>
                  </div>
                    <button *ngIf="actionControls.isAdd" data-toggle="modal" data-target="#exampleModal"><i class="bi bi-plus-lg"></i> Add</button>
                </div>
            </div>
          
            <table class="table table-striped">
                <thead>
                    <tr>
                      <th style="width: 30%;">Ticket-sub Type</th>
                      <th style="width: 30%;">Remarks</th>
                      <th style="width: 30%;">Version</th>
                      <th style="width: 10%;">Action</th>
                    </tr>
                </thead>
            </table>
            <div *ngIf="!isLoading">
              <div class="data-view" *ngFor="let ticket of sub_ticket | paginate : {
                itemsPerPage: tableSize,
                currentPage: pageNumber,
                totalItems: totalRecords
                }  let i = index">
  
                  <p style="width: 30%;">{{ticket.name}}</p>
                  <p style="width: 30%;padding-left: 25px;">{{ticket.remarks}}</p>
                  <p style="width: 30%;padding-left: 25px;">{{ticket.version}} </p>
                  <p class="action-buttons" style="width: 10%;padding-left: 15px;">
                    <i *ngIf="actionControls.isModify" (click)="getTicketSubTypeById(ticket.ticketSubTypeId)" data-toggle="modal" data-target="#updateModal" class="bi bi-pencil-square"></i>
                    <i *ngIf="actionControls.isDelete" (click)="del(ticket.id)" data-toggle="modal" data-target="#deleteModal" class="bi bi-trash3"></i>
                </p>
              </div>
            </div>



            <div class="loader" *ngIf="isLoading">
              <div class="spinner"></div>
          </div>
  
          <div class="loader" *ngIf="!isLoading && sub_ticket.length == 0">
              <div class="no-data">
                  <img src="assets/no-data-6.png" alt="">
                  <p>no data found</p>
              </div>
              
          </div>

          <div class="paginator">
            <p-paginator (onPageChange)="onTableDataChange($event)" [first]="first" [rows]="tableSize" [totalRecords]="totalRecords"
                [showFirstLastIcon]="false" [showCurrentPageReport]="true" currentPageReportTemplate="{first} - {last} of {totalRecords}"></p-paginator>
        </div>
  
        </div>
      </div>
  </div>
</div>


<div class="modal fade" id="exampleModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
<div class="modal-dialog modal-dialog-centered">
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title" id="exampleModalLabel">Add Sub-Ticket
        <span data-dismiss="modal">
          <i class="bi bi-x-lg"></i>
        </span>
      </h5>
    </div>
    <div class="modal-body">

      <div [formGroup]="form">

          <div class="form-group">
              <label>Sub-Ticket Name</label>
              <input formControlName="name" type="text" class="form-control">
          </div>

          <div class="form-group">
              <label>Remarks</label>
              <textarea name="" formControlName="remarks" id="" class="form-control" cols="30" rows="10"></textarea>
          </div>

          <!-- <div class="form-group">
              <label>Type ID</label>
              <input  type="text" formControlName="Type_ID" class="form-control">
          </div> -->
          <div class="form-group">
              <label>Version</label>
              <input  type="text" formControlName="version" class="form-control">
          </div>
      </div>

 
    <div class="modal-footer">
      <button type="button" id="closeModalButton"   class="btn btn-secondary" data-dismiss="modal">Cancel</button>
      <button type="button" (click)="addSubticket()" class="btn btn-primary">Add Sub-Ticket Type</button>
    </div>
  </div>
</div>
</div>
</div>



<div class="modal fade" id="deleteModal" tabindex="-1" data-backdrop="static" aria-labelledby="deleteModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="deleteModalLabel">Confirmation!!
          <span data-dismiss="modal">
            <i class="bi bi-x-lg"></i>
          </span>
        </h5>
      </div>
      <div class="modal-body">
        <p>are you sure? want to delete??</p>
      <div class="modal-footer">
        <button type="button" id="closeModalButton1"   class="btn btn-secondary" data-dismiss="modal">Cancel</button>
        <button type="button" (click)="delSubTicket()" class="btn btn-primary">Delete</button>
      </div>
    </div>
  </div>
</div>
</div>


<div class="modal fade" id="updateModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">UPDATE TICKET SUB-TYPE
          <span data-dismiss="modal">
            <i class="bi bi-x-lg"></i>
          </span>
        </h5>
      </div>
      <div class="modal-body">

        <div [formGroup]="editForm">

            <div class="form-group">
                <label>Sub-Ticket Name</label>
                <input formControlName="name" type="text" class="form-control">
            </div>

            <div class="form-group">
                <label>Remarks</label>
                <textarea name="" formControlName="remarks" id="" class="form-control" cols="30" rows="10"></textarea>
            </div>
            <div class="form-group">
                <label>Version</label>
                <input  type="number" formControlName="version" class="form-control">
            </div>
        </div>

      <div class="modal-footer">
        <button type="button" id="closeModalButton2" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
        <button type="button" (click)="updateTicketSubType()" class="btn btn-primary">save changes</button>
      </div>
    </div>
  </div>
</div>
</div>